"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultValue = void 0;
var tslib_1 = require("tslib");
var noop_1 = require("../_util/noop");
var use_default_1 = require("../_util/use-default");
function useDefaultValue(props, defaultDefaultValue) {
    var defaultValue = props.defaultValue, value = props.value, _a = props.onChange, onChange = _a === void 0 ? noop_1.noop : _a, restProps = (0, tslib_1.__rest)(props, ["defaultValue", "value", "onChange"]);
    var _b = (0, tslib_1.__read)((0, use_default_1.useDefault)(value, typeof defaultValue === 'undefined' ? defaultDefaultValue : defaultValue, onChange), 2), finalValue = _b[0], finalOnChange = _b[1];
    /* eslint-disable @typescript-eslint/consistent-type-assertions */
    return (0, tslib_1.__assign)({ value: finalValue, onChange: finalOnChange }, restProps);
    /* eslint-enable @typescript-eslint/consistent-type-assertions */
}
exports.useDefaultValue = useDefaultValue;
